'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducers = exports.defaultState = undefined;

var _constant2 = require('lodash/constant');

var _constant3 = _interopRequireDefault(_constant2);

var _reducers;

var _capeRedux = require('cape-redux');

var _capeLodash = require('cape-lodash');

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = exports.defaultState = {
  item: null,
  collection: null,
  listItem: null
};

var reducers = exports.reducers = (_reducers = {}, _defineProperty(_reducers, _actions.CLOSE, (0, _constant3.default)(defaultState)), _defineProperty(_reducers, _actions.COLLECTION, (0, _capeLodash.set)('collection')), _defineProperty(_reducers, _actions.LISTITEM, (0, _capeLodash.set)('listItem')), _defineProperty(_reducers, _actions.OPEN, (0, _capeLodash.set)('item')), _reducers);
var reducer = (0, _capeRedux.createReducer)(reducers, defaultState);
exports.default = reducer;


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-collection/lib/reducer.js
// module id = 843
// module chunks = 0